<template >
  <b-container class="pb-5 text-center" fluid>
    <b-row class="mf_1row">
      <b-col cols="12" lg="8" class="mf_fp_col_title">
        <TitleBig content="Votre proposition de portefeuille optimisé" />
        <TitleFree />
        <hr />
        <div>
          <p class="mf_subtitle">
            Découvrez vos indicateurs annualisés de portefeuille !
          </p>
          <p class="mf_title_text mf_spacing">
            Ces indicateurs correspondent à la performance de votre portefeuille
            selon l'horizon temporel défini initialement.
          </p>
          <p class="mf_title_text">
            Pour plus d'information consultez notre article
            <a href="/notre-vue-des-marchés" target="_blank" rel="noopener"
              >ici</a
            >
          </p>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <Mockup src="fp_optimizer_mockup.svg" />
      </b-col>
    </b-row>
    <hr class="mt-5" />
    <b-row class="mf_2row">
      <b-col cols="12">
        <div class="row_title_modal">
          <TitleSub content="Votre allocation optimisée" />
          <span class="ml-2">
            <ModalInfo
              title="Votre allocation optimisée"
              content="<p>L'allocation optimisée correspond à l'allocation efficiente (celle qui maximise le couple rendement / risque) de votre investissement.</p>
              <p>Pour plus d'informations consultez notre article.</p>"
            />
          </span>
        </div>
      </b-col>
      <b-col cols="12" class="mt-5 p-1"><ChartDog :sectors="sectors" /></b-col>
    </b-row>
    <hr class="mt-5" />
    <b-row class="fp_opt_row3">
      <b-col cols="12" class="mb-4">
        <div class="row_title_modal">
          <TitleSub content="Vos indicateurs annualisés de portefeuille" />
          <span class="ml-2">
            <ModalInfo
              title="Vos indicateurs annualisés de portefeuille"
              content="<p>L'ensemble des indicateurs présentés dans cette section sont calculés à partir de la date de création historique de votre portefeuille. C'est à dire date à laquelle tous les ETF de votre portefeuille ont commencé à être côté sur les marchés financiers.</p>
              <p>Plus les ETF que vous avez sélectionnés sont anciens plus vos indicateurs ont été calculé avec suffisamment de recul.</p>
              <p>Tous les indicateurs évoqués sont annualisés.</p>"
            />
          </span>
        </div>
      </b-col>
      <b-col cols="6">
        <b-row class="row_bloc_modal">
          <SmallBloc
            :data="Math.round(sharpe_ratio * 100) / 100"
            title="Score performeur"
          />
          <ModalInfo
            title="Score performeur"
            content="<p>Le score performeur all (toute période) reflète le couple historique (rendement / risque) et annualisé de votre portefeuille.</p>
            <p>Tout comme notre score performeur 1Y : Plus le score est élevé plus le couple rendement/risque a été avantageux pour l'investisseur.</p>
            <p>Si le score est supérieur à 1 : La performance du portefeuille a été très bonne. (La performance obtenue a été supérieure au risque pris par l'investisseur).</p>
            <p>Si le score est inférieur à 1 : La performance du portefeuille n'a pas été suffisamment élevée pour compenser le risque encouru par l'investisseur.</p>
            <p>Le score performeur correspond au ratio de Sharpe annualisé (pour ceux qui connaissent)</p>
            "
          />
        </b-row>
        <b-row class="row_bloc_modal">
          <SmallBloc
            :data="Math.round(port_return) + '%'"
            title="Performance"
          />
          <ModalInfo
            title="Performance"
            content="
            <p>Performance annualisée depuis la date historique de création de votre portefeuille.</p>
            "
          />
        </b-row>
      </b-col>
      <b-col cols="6">
        <b-row class="row_bloc_modal">
          <SmallBloc :data="Math.round(volatility) + '%'" title="Volatilité" />
          <ModalInfo
            title="Volatilité"
            content="<p>Volatilité annualisée depuis la date historique de création de votre portefeuille.</p>"
          />
        </b-row>
        <b-row class="row_bloc_modal">
          <SmallBloc
            :data="Math.round(climate_score) + '/100'"
            title="Score impact"
          />
          <ModalInfo
            title="Score impact"
            content="<p>Le score IMPACT correspond à l'impact du fond sur notre société.</p>
            <p>
              Plus le score est proche de 100 plus le fond finance des entreprises
              avec un impact positif sur notre environnement.
            </p>
            <p>
              Ce score a été calculé en calculant la moyenne pondéré des scores
              attribués à chacune des entreprises comprises dans l'ETF.
            </p>
            <p>
              Parmi les critères pris en compte dans le calcul des scores, nous
              retrouvons :
            </p>
            <p>
              Critères Environnementaux : Taux d'émission de CO2 / Taux d'utilisation
              ou de production d'énergie verte / Taux de recyclage des déchets /
              Prévention des risques (marées noires,contamination, déjection)
            </p>
            <p>
              Critères Sociaux : Taux de représentation Homme-Femme / Emploi des
              personnes handicapés / Prévention des risques / Formation interne /
              Respect du droit des employés.
            </p>
            <p>
              Critères de Gouvernance : Transparence de la rémunération / Indépendance
              des conseils d'administration / Comité de vérification des comptes /
              Lutte contre la corruption.
            </p>
            <p>
            Pour plus d'information sur ce score, consultez notre article.
            <p>"
          />
        </b-row>
        <!-- <TitleSub
          content="Les indicateurs historiques et annualisés de votre portefeuille optimisé"
        /> -->
      </b-col>
    </b-row>
    <hr class="mt-5" />
    <b-row class="fp_opt_row4">
      <b-col cols="12">
        <TitleSub content="Estimation de l'évolution de votre capital" />
      </b-col>
      <b-col cols="12" class="mt-5"><ChartLine :capital="capital" /></b-col>
    </b-row>
    <hr class="mt-5" />
    <b-row v-if="is_public" class="fp_opt_row5">
      <b-col cols="12">
        <TitleSub
          content="Voici le ou les compte(s) à ouvrir pour optimiser votre fiscalité"
        />
      </b-col>
      <b-col cols="12" class="mt-2">
        <TextSm
          content="Pour optimiser votre fiscalité vous devez ouvrir un PEA et un compte
          titre avec la composition suivante :"
        />
      </b-col>
      <b-col v-if="portfolio_pea[0]" cols="12" class="mt-4">
        <DpComptes
          title="PEA (Plan d'épargne en Action)"
          :datas="portfolio_pea"
          :platforms="platforms_pea"
        />
      </b-col>
      <b-col v-if="portfolio_av[0]" cols="12" class="mt-4">
        <DpComptes
          title="Assurance-vie"
          :datas="portfolio_av"
          :platforms="platforms_av"
        />
      </b-col>
      <b-col v-if="portfolio_ct[0]" cols="12" class="mt-4">
        <DpComptes
          title="Compte titre"
          :datas="portfolio_ct"
          :platforms="platforms_ct"
        />
      </b-col>
    </b-row>
    <b-row v-else class="fp_opt_row6">
      <b-col cols="12">
        <TitleSub content=" Sauvegarder ce portefeuille" />
      </b-col>
      <b-col cols="12" class="mt-3">
        <SavePortfolio
          :portfolio_id="portfolio_id"
          :token="token"
        />
      </b-col>
      <b-col cols="12" class="mt-3">
        <TextSm
          content="Les performances passées ne préjugent pas des performances futures."
        />
      </b-col>
    </b-row>
    <hr class="mt-5" />
    <b-row class="fp_opt_row6">
      <b-col cols="12">
        <TitleSub
          content=" Vous souhaitez améliorer vos performances et comparer différents
          portefeuilles ?"
        />
      </b-col>
      <b-col cols="12" class="mt-3">
        <BtnOptimisation />
      </b-col>
      <b-col cols="12" class="mt-3">
        <TextSm
          content="Les performances passées ne préjugent pas des performances futures."
        />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import TitleBig from "../components/TitleBig.vue";
import TitleFree from "../components/TitleFree.vue";
import Mockup from "../components/Mockup.vue";
import SmallBloc from "./comps/SmallBloc.vue";
import TitleSub from "./comps/TitleSub.vue";
import TextSm from "./comps/TextSm.vue";
import ChartDog from "./comps/ChartDog.vue";
import ChartLine from "./comps/ChartLine.vue";
import DpComptes from "./comps/DpComptes.vue";
import BtnOptimisation from "./comps/BtnOptimisation.vue";
import SavePortfolio from "./comps/SavePortfolio.vue";
import ModalInfo from "../components/ModalInfo.vue";

export default {
  props: [
    "sharpe_ratio",
    "climate_score",
    "port_return",
    "volatility",
    "sectors",
    "capital",
    "portfolio_pea",
    "platforms_pea",
    "portfolio_av",
    "platforms_av",
    "portfolio_ct",
    "platforms_ct",
    "is_public",
    "portfolio_id",
    "token"
  ],
  components: {
    SmallBloc,
    TitleSub,
    TextSm,
    ChartDog,
    TitleBig,
    TitleFree,
    Mockup,
    ChartLine,
    BtnOptimisation,
    SavePortfolio,
    DpComptes,
    ModalInfo
  }
};
</script>
<style lang="scss" scoped>
.row_title_modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.row_bloc_modal {
  align-items: center;
  justify-content: center;
}
</style>